// Action Types
export const NEWSPAPER_APPROVAL_START = 'NEWSPAPER_APPROVAL_START';
export const NEWSPAPER_APPROVAL_SUCCESS = 'NEWSPAPER_APPROVAL_SUCCESS';
export const NEWSPAPER_APPROVAL_FAILURE = 'NEWSPAPER_APPROVAL_FAILURE';

export const APPROVE_NEWSPAPER_START = 'APPROVE_NEWSPAPER_START';
export const APPROVE_NEWSPAPER_SUCCESS = 'APPROVE_NEWSPAPER_SUCCESS';
export const APPROVE_NEWSPAPER_FAILURE = 'APPROVE_NEWSPAPER_FAILURE';

export const REJECT_NEWSPAPER_START = 'REJECT_NEWSPAPER_START';
export const REJECT_NEWSPAPER_SUCCESS = 'REJECT_NEWSPAPER_SUCCESS';
export const REJECT_NEWSPAPER_FAILURE = 'REJECT_NEWSPAPER_FAILURE';

export const DELETE_NEWSPAPER_START = 'DELETE_NEWSPAPER_START';
export const DELETE_NEWSPAPER_SUCCESS = 'DELETE_NEWSPAPER_SUCCESS';
export const DELETE_NEWSPAPER_FAILURE = 'DELETE_NEWSPAPER_FAILURE';

export const BULK_APPROVE_NEWSPAPER_START = 'BULK_APPROVE_NEWSPAPER_START';
export const BULK_APPROVE_NEWSPAPER_SUCCESS = 'BULK_APPROVE_NEWSPAPER_SUCCESS';
export const BULK_APPROVE_NEWSPAPER_FAILURE = 'BULK_APPROVE_NEWSPAPER_FAILURE';

// New: clear/reset transient responses to avoid stale messages on navigation
export const CLEAR_NEWSPAPER_STATUS = 'CLEAR_NEWSPAPER_STATUS';

// Interfaces
export interface NewspaperAllowance {
	subscriptionID: number;
	employeeID: string;
	empID: string;
	employeeName: string;
	branchName: string;
	firstNewspaperID: number | null;
	secondNewspaperID: number | null;
	firstNewspaperName: string | null;
	secondNewspaperName: string | null;
	firstNewspaperCost: string;
	secondNewspaperCost: string;
	totalCost: string;
	month: number;
	year: number;
	billImage: string | null;
	status: string | null;
	approvedDate?: string | null;
	rejectedDate?: string | null;
	createdDate: string;
}

export interface NewspaperResponse {
	status: string;
	message: string;
	record_count?: number;
	data: NewspaperAllowance[];
}

export interface NewspaperAction {
	type: string;
	payload?: any;
	[key: string]: any;
}

export interface NewspaperState {
	newspaperApprovalResponse: NewspaperResponse | null;
	approveNewspaperResponse: any;
	rejectNewspaperResponse: any;
	deleteNewspaperResponse: any;
	bulkApproveNewspaperResponse: any;
	loading: boolean;
	error: string | null;
}
